export default __webpack_public_path__ + "static/media/spanish.15e3adca.svg";